
import React from 'react'
import { useDispatch } from 'react-redux'
import { Form } from 'react-bootstrap'

import useTranslation from '../../../Hooks/UseTranslation'
import { useProgrammation } from '../../../Hooks/UseProgrammation'
import { updateTaskField } from '../../../Services/ProgrammationManagerService'

import { updateTaskFieldAction } from '../../../Redux/Actions/ProgrammationManagerActions'

import InputSelect from '../components/InputSelect'

import './TaskType.scss'

interface Props {
  type: string | undefined
}

const TaskType = ({ type }: Props) => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { itemOpened, patchItemOpened, setEditingItem } = useProgrammation()

  const types: any = {
    'partida': { label: t('TASK_TYPES:Partida') },
    'trabajo': { label: t('TASK_TYPES:Trabajo') },
    'tarea': { label: t('TASK_TYPES:Task') },
    'diseño': { label: t('TASK_TYPES:Design') },
    'reunion': { label: t('TASK_TYPES:Meeting') },
    'hito': { label: t('TASK_TYPES:Milestone') },
  }

  const typesOptions = Object.keys(types).map((type: string) => ({
    value: type,
    label: types[type].label,
  }))

  const handleChangeType = async (type: string) => {

    // Note: this handler is only reachable for types other than 'trabajo',
    // because the JSX below only mounts <InputSelect> (which dispatches this
    // onChange) when `type !== 'trabajo'`. Tasks with type 'trabajo' are
    // rendered as a read-only badge, so no API call is needed for them.
    setEditingItem(true)

    const [ error, data ] = await updateTaskField(itemOpened._id, 'type', type)

    setEditingItem(false)

    if (error) {
      return console.log(error)
    }

    const serverType = data?.task?.type ?? type

    patchItemOpened({
      type: serverType,
    })

    await dispatch(updateTaskFieldAction(itemOpened._id, 'type', serverType))
  }

  return (
    <Form.Group>
      <Form.Label>
        {t('PROGRAMMATION_MANAGER:TypeLabel')}
      </Form.Label>
      {(!type || (type && !itemOpened.hasSubTasks && type !== 'trabajo')) && (
          <InputSelect
            value={type || ''}
            onChange={handleChangeType}
            options={typesOptions}
            renderOption={(option: any) => (
              <option value={option.value}>
                {option.label}
              </option>
            )}
          />
      )}
      {((type === 'partida' && itemOpened.hasSubTasks) || type === 'trabajo') && (
        <div className='task-type'>
          <div className={`type-color ${type}`}>
            <span className='icon-tareas'></span>
          </div>
          {types[type].label}
        </div>
      )}
    </Form.Group>
  )
}

export default TaskType
